<template>
	<div class="search-icd">
		<v-autocomplete
			solo
			v-model="icd"
			:items="icdOptions"
			:loading="loadingICD"
			:search-input.sync="search"
			:hide-no-data="hideNoData"
			:hide-selected="!productContext"
			:item-text="displayName"
			item-value="code"
			:placeholder="$gettext('Search ICD-11')"
			clearable
			return-object
			outlined
			no-filter
			:no-data-text="$gettext('No results found')"
			@input="!productContext ? clickICD() : null"
			prepend-inner-icon="search"
			hide-details
			class="mb-2"
			:disabled="disabled"
			:style="$store.getters.tourMode ? {'position': 'relative', 'z-index': 400, 'background': '#FFFFFF'} : ''"
			:multiple="productContext"
			:append-outer-icon="productContext && this.icd ? 'mdi-sticker-check-outline' : null"
			@click:append-outer="addICDs"
			@focus="icd = null"
		>
			<template v-if="productContext" v-slot:selection="data">
				<v-chip
					v-bind="data.attrs"
					:input-value="data.selected"
					close
				>{{ data.item.code }}</v-chip>
			</template>
		</v-autocomplete>
		<ICDList
			:list="icdList"
			@remove-icd="removeICD"
			@open-send-monitoring-email="$emit('open-send-monitoring-email')"
			:context="context"
			:patient="patient"
			:showIntensity="type == 'gen_diagnose' || type == 'mtc_diagnose' ? true : false"
			:disabled="disabled"
		/>
		<v-dialog v-model="showRelationOptions" width="50%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Relation</translate>
					<span class="ml-1" v-if="icd && icd.code != -1">- {{icd.title}}</span>
				</v-card-title>
				<v-card-text>
					<v-row no-gutters class="mt-3">
						<v-col cols="12">
							Grau
							<v-rating
								small
								v-model="degree"
								length="10"
								empty-icon="mdi-checkbox-blank-circle-outline"
								full-icon="mdi-checkbox-blank-circle"
								hover
								dense
								color="primary"
								background-color="secondary"
							></v-rating>
							{{degree}}
						</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="addICD">
						<translate>Add</translate>
					</v-btn>
					<v-btn color="primary darken-1" text @click="showRelationOptions = false; icd = null; icdOptions = []">
						<translate>Cancel</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";
import ICDList from "@/components/icd/ICDList.vue";
import { mapGetters } from 'vuex'

export default {
	name: "SearchICD",
	props: {
		selectedICD: {},
		selectedICDSingle: {},
		context: {
			default: "appointment"
		},
		type: {},
		patient: {
			default: () => ({})
		},
		disabled: {
			default: false
		}
	},
	components: {
		ICDList
	},
	data: () => ({
		icd: null,
		icdOptions: [],
		search: "",
		loadingICD: false,
		showRelationOptions: false,
		degree: 1
	}),
	methods: {
		clickICD() {
			if(this.context == 'new-product') this.showRelationOptions = true;
			else this.addICD()
		},
		addICDs() {
			console.log("ADD", this.icd);
			let diseases = [];
			let exist;
			for (let i = 0; i < this.icd.length; i++) {
				exist = false;
				for (let z = 0; z < this.selectedICD.length; z++) {
					if (this.selectedICD[z].disease_id == this.icd[i].disease_id) {
						exist = true;
						break;
					}
				}
				if(!exist) diseases.push(this.icd[i]);
			}
			if(diseases) {
				axios
					.post("/icds", diseases)
					.then(response => {
						console.log(response.data);
						//this.icd = response.data.diseases;
						//this.icd.degree = this.degree;
						response.data.diseases.forEach(d => {
							d.degree = this.degree;
							this.selectedICD.push(d);
						})
						this.showRelationOptions = false;
						
						this.icd = null;
						this.search = "";
					})
					.catch(error => {
						console.log(error);
					});
			}
		},
		displayName(i) {
			return i.code + " - " + i.title;
		},
		removeICD: function(icd) {
			//CALL API
			if (icd) {
				if (this.context === "appointment") {
					//CALL API
					console.log("REMOVE ICD");
					const appointmentId = this.$route.params.aid;
					axios
						.post("/app/symptom", null, {
							params: {
								appointment: appointmentId,
								model: "ICD11",
								disease_id: icd.disease_id,
								action: "delete",
								type: this.type,
								main: false
							}
						})
						.then(response => {
							console.log(response.data);
							if (response.status === 200) {
								if (response.data.result === "deleted") {
									this.$emit("remove-icd", icd);
								}
							}
						})
						.catch(error => console.log(error));
				} else if (this.context === "new-product" || this.context == 'tests') {
					this.selectedICD.splice(this.selectedICD.indexOf(icd), 1);
				} else if (this.context === "monitoring") {
					this.selectedICDSingle.disease = null;
				} else {
					this.$emit("remove-icd", icd);
				}
			}
		},
		addICD: function() {
			if (this.icd) {
				console.log(this.icd);
				var exist = false;
				if (this.context != "monitoring") {
					for (var i = 0; i < this.selectedICD.length; i++) {
						if (this.selectedICD[i].disease_id == this.icd.disease_id) {
							exist = true;
							break;
						}
					}
				}
				if (!exist) {
					if (this.context === "appointment") {
						//CALL API
						console.log("ADD ICD");
						const appointmentId = this.$route.params.aid;
						const icd = this.icd;
						axios
							.post("/app/symptom", null, {
								params: {
									appointment: appointmentId,
									model: "ICD11",
									disease_id: this.icd.disease_id,
									action: "add",
									type: this.type,
									main: false
								}
							})
							.then(response => {
								console.log(response.data);
								if (response.status === 200) {
									if (response.data.result === "added") {
										icd.type = this.type;
										response.data.symptoms.forEach(s => {
											this.$emit("add-icd", s);
										});
									}
								}
							})
							.catch(error => console.log(error));
					} else {
						axios
							.get("/icd/" + this.icd.disease_id)
							.then(response => {
								this.icd = response.data.disease;
								if (this.context === "monitoring") {
									this.selectedICDSingle.disease = this.icd;
								} else {
									console.log("yoyo");
									this.icd.degree = this.degree;
									this.selectedICD.push(this.icd);
									this.showRelationOptions = false;
								}
								this.icd = null;
							})
							.catch(error => {
								console.log(error);
							});
					}
				}
				this.icd = null;
				this.search = null;
				this.icdOptions = [];
			}
		},
		makeRequest: function(value, self) {
			clearTimeout(this._timerId);
			self.loadingICD = true;
			// delay new call 500ms
			this._timerId = setTimeout(() => {
				console.log("API CALL");
				const chapter = this.type == "mtc_diagnose" ? "mtc" : "all";
				axios
					.get("/icd/search", {
						params: { value: value, chapter: chapter, page: 1, all_data: false }
					})
					.then(response => {
						console.log(response.data);
						self.icdOptions = response.data;
						self.loadingICD = false;
					})
					.catch(error => {
						console.log(error);
						self.loadingICD = false;
					});
			}, 300);
		}
	},
	computed: {
		hideNoData() {
			return this.search == "";
		},
		icdList() {
			if (this.context == "monitoring") {
				if (this.selectedICDSingle.disease)
					return [this.selectedICDSingle.disease];
				else return [];
			} else {
				return this.selectedICD;
			}
		},
		productContext() {
			return this.context == 'new-product';
		},
		...mapGetters({
      tourStep: 'tourStepEvent'
    })
	},
	watch: {
		search(value) {
			if (!value) {
				this.icdOptions = [];
				return;
			}

			console.log("CALL DEBOUNCE");
			this.icdOptions = [];
			this.makeRequest(value, this);
		},
		tourStep(value) {
			if(this.type == 'chief_complaint' && value == 'tour-anamnesis-main-complaint') {
				this.icd = {disease_id: 12646};
				this.addICD();
			}
		}
	}
};
</script>